module.exports = __webpack_public_path__ + "static/media/14PerformancePhotos.550c9204.jpeg";